import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { Icon } from '@codex/icons';

const Wrapper = styled.span`
  cursor: pointer;
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: none;
  }
`;

const StyledText = styled.span`
    font-family: CurrysSans;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primary.purple};
    margin-right: 8px;
`;

const StyledIcon = styled(Icon)`
  margin-top: -5px;
  color: ${(props) => props.theme.colors.primary.purple};
`;

const MoreInfoButton = ({ isDisplayed, onClick, moreInfoText }) => {
  if (!isDisplayed) {
    return null;
  }

  return (
    <EnvironmentThemeProvider>
      <Wrapper onClick={onClick}>
        <StyledText>{moreInfoText}</StyledText>
        <StyledIcon icon={'Info'} />
      </Wrapper>
    </EnvironmentThemeProvider>
  );
};

MoreInfoButton.propTypes = {
  isDisplayed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  moreInfoText: PropTypes.string.isRequired
};

export default MoreInfoButton;
